/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Button, TemporaryDrawer } from '@coursera/cds-core';
import { ContextualHelpIcon } from '@coursera/cds-icons';

import { CMLOrHTML } from 'bundles/cml';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import { processContent } from 'bundles/grading/utils/formPartUtils';
import { hasSubmission } from 'bundles/grading/utils/submissionUtils';

import _t from 'i18n!nls/grading';

const { HeadingGroup, Content } = TemporaryDrawer;

// Component for Grader Instructions
const GraderInstructions: React.FC = () => {
  const [isOpen, setOpen] = React.useState(false);

  const toggleDrawer = () => {
    setOpen((prevState) => !prevState);
  };

  const { submissionData } = useContext(SGAPageContext);

  const { graderInstructions } = submissionData.data || {};

  if (
    !submissionData.data?.submitter ||
    (!graderInstructions && !hasSubmission(submissionData.data.submitter.submittedAt))
  ) {
    return null;
  }

  const cmlOrHtmlValue = graderInstructions
    ? processContent(graderInstructions)
    : _t('No grading instructions available');

  return (
    <div>
      <Button variant="ghost" icon={<ContextualHelpIcon />} iconPosition="before" onClick={toggleDrawer} size="small">
        {_t('Grader instructions')}
      </Button>
      <TemporaryDrawer
        open={isOpen}
        anchor="right"
        sticky="none"
        width="medium"
        onClose={toggleDrawer}
        aria-describedby="grader-instructions-drawer-content"
        data-testid="grader-instructions-drawer"
      >
        <HeadingGroup>{_t('Grader instructions')}</HeadingGroup>

        <Content id="grader-instructions-drawer-content">
          <CMLOrHTML value={cmlOrHtmlValue} />
        </Content>
      </TemporaryDrawer>
    </div>
  );
};

export default GraderInstructions;
